import { get } from "lodash-es";

export const selectSmartService = (state) => state.visaForm.smartService;
export const selectSmartServiceLTR = (state) => state.visaForm.LTRList;
export const selectSmartServiceListLTRExtra = (state) => state.visaForm.smartServiceListLTRExtra;
export const selectDocumentRequired = (state) =>
  state.visaForm.documentRequired;

export const selectCoditionVisa = (state) => state.visaForm.coditionVisa;
export const selectCoditionType = (state) => state.visaForm.coditionType;
export const selectCurrentSmartServiceId = (state) =>
  state.visaForm.currentDocument.smartserviceId;
export const selectCurrentSmartServiceIdType = (state) =>
  state.visaForm.currentDocument.smartform.smartserviceId;
export const selectCurrentConditionType = (state) =>
  state.visaForm.currentDocument.ConditionType;
export const selectCurrentSmartForm = (state) =>
  state.visaForm.currentDocument.smartform;
export const selectCurrentDocument = (state) => state.visaForm.currentDocument;
export const selectSmartFormFieldConfig = (state) => state.visaForm.fieldConfig;
export const selectAddSmartForm = (state) => state.visaForm.addSmartForm;
export const selectDraftId = (state) =>
  get(selectAddSmartForm(state), "data.draftId", null);
export const selectListSmartForm = (state) => state.visaForm.list;
export const selectSubmitSmartForm = (state) => state.visaForm.submit;
export const selectSmartFormChange = (state) => state.visaForm.smartFormChange;
export const selectSmartFormExtension = (state) =>
  state.visaForm.smartFormExtension;
export const selectAddExtension = (state) => state.visaForm.addExtension;
export const selectCheckSmartO = (state) => state.visaForm.checkSmartO;
export const selectReqdoclogList = (state) => state.visaForm.reqdoclogList;
export const selectCheckRequestSmartForm = (state) =>
  state.visaForm.checkRequestSmartForm;
export const selectCheckWorkPermit = (state) =>
  state.visaForm.checkWorkPermit;
export const selectAddWorkPermit = (state) =>
  state.visaForm.addWorkPermit;
